/* One browser-based path for guests and signed-in customers. No tracking events. */
(() => {
  'use strict';
  if (window.NSExchangeReminder) return;
  const config = Object.assign({enabled: true, storageKey: 'ns_exchange_reminder_v1', days: 30}, window.NSExchangeConfig);
  const ttl = config.days * 86400000;
  const bypass = new WeakSet();
  const seen = new Set();
  let pending = false, dialog = null, anyShown = false;
  const id = value => String(value || '').split('/').pop();
  function allowed() {
    if (!config.enabled) return false;
    try { return typeof window.NSExchangeConsent === 'function' ? window.NSExchangeConsent() === true : true; }
    catch (_) { return false; }
  }
  function validRecords(input) {
    if (!Array.isArray(input)) return [];
    const now = Date.now();
    return input.filter(r => r && /^\d+$/.test(id(r.productId)) && /^\d+$/.test(id(r.variantId)) &&
      Number.isFinite(r.at) && r.at <= now && now - r.at < ttl).slice(-80);
  }
  function read() {
    if (!allowed()) return [];
    try {
      const raw = localStorage.getItem(config.storageKey);
      const all = raw ? JSON.parse(raw) : [];
      const records = validRecords(all);
      if (raw && JSON.stringify(records) !== raw) {
        if (records.length) localStorage.setItem(config.storageKey, JSON.stringify(records));
        else localStorage.removeItem(config.storageKey);
      }
      return records;
    } catch (_) { return []; }
  }
  function productFor(form) {
    const nodes = document.querySelectorAll('.ns-exchange-product');
    for (const node of nodes) {
      if (node.dataset.formId === form.getAttribute('id')) {
        try { return JSON.parse(node.textContent); } catch (_) { return null; }
      }
    }
    return null;
  }
  function sizeIndex(product) {
    return (product.options || []).findIndex(o => /^(size|størrelse|storlek|taille|shoe size)$/i.test(typeof o === 'string' ? o.trim() : o.name.trim()));
  }
  function numericSize(value) {
    const text = String(value || '').trim().replace(',', '.').replace(/^EU\s*/i, '');
    const match = text.match(/^(\d{1,2}(?:\.\d+)?)\s*(?:([12])\s*\/\s*3)?$/);
    return match ? Number(match[1]) + (match[2] ? Number(match[2]) / 3 : 0) : null;
  }
  function match(product, variantId, records) {
    if (!product || !Array.isArray(product.variants)) return null;
    const index = sizeIndex(product);
    if (index < 0) return null;
    const variant = product.variants.find(v => id(v.id) === id(variantId));
    if (!variant || variant.available === false) return null;
    const options = v => v.options || [v.option1, v.option2, v.option3].filter(x => x != null);
    const selected = options(variant);
    const compatible = v => options(v).every((value, i) => i === index || value === selected[i]);
const clothingSizes = [
  'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '4XL', '5XL'
];

const clothingSize = value => {
  const label = String(value || '')
    .trim()
    .toUpperCase()
    .replace(/^2XL$/, 'XXL')
    .replace(/^3XL$/, 'XXXL');

  const position = clothingSizes.indexOf(label);
  return position < 0 ? null : position;
};

const isClothing = clothingSize(selected[index]) !== null;
const parseSize = isClothing ? clothingSize : numericSize;
const maxStep = isClothing ? 1 : 1.5;
const currentSize = parseSize(selected[index]);    if (currentSize === null) return null;
const sizes = [...new Set(product.variants.filter(compatible).map(v => parseSize(options(v)[index])).filter(n => n !== null))].sort((a,b) => a-b);    for (const record of records.slice().sort((a,b) => b.at-a.at)) {
      if (id(record.productId) !== id(product.id)) continue;
      const old = product.variants.find(v => id(v.id) === id(record.variantId));
      if (!old || !compatible(old)) continue;
const previous = parseSize(options(old)[index]);      // Numeric shoe sizes only; one adjacent offered size, at most 1.5 EU sizes apart.
      if (previous === null || previous === currentSize || Math.abs(previous-currentSize) > maxStep ||
          Math.abs(sizes.indexOf(previous)-sizes.indexOf(currentSize)) !== 1) continue;
      const key = [record.productId, record.variantId, record.at].join(':');
      if (seen.has(key)) continue;
      return {key, product, oldSize: options(old)[index], newSize: selected[index]};
    }
    return null;
  }
  function close() {
    if (dialog) { dialog.close(); dialog.remove(); dialog = null; }
    pending = false;
  }
  function show(info, continuePurchase) {
    if (pending || !window.HTMLDialogElement || typeof HTMLDialogElement.prototype.showModal !== 'function') return false;
    const element = document.createElement('dialog');
    element.className = 'ns-exchange-dialog';
    element.setAttribute('aria-labelledby', 'ns-exchange-heading');
    element.setAttribute('aria-describedby', 'ns-exchange-description');
    element.innerHTML = '<div class="ns-exchange-label">Gratis ombytning</div><h2 id="ns-exchange-heading">Skal du bruge en anden størrelse?</h2><p id="ns-exchange-description"></p><a>Gå til ombytning</a><button type="button" autofocus>Fortsæt med nyt køb</button>';
    element.querySelector('p').textContent = `Du har for nylig købt ${info.product.title} i størrelse ${info.oldSize}. Hvis størrelsen ikke passer, tilbyder vi gratis ombytning. Du behøver derfor ikke købe varen igen for at skifte størrelse..`;
    const link = element.querySelector('a');
    link.href = config.exchangeUrl || 'https://returportal.nordicsneakers.dk/returportal';
    link.addEventListener('click', close);
    element.querySelector('button').addEventListener('click', () => { close(); continuePurchase(); });
    // Escape / backdrop dismisses the reminder but does not place an order or add an item.
    element.addEventListener('cancel', event => { event.preventDefault(); close(); });
    element.addEventListener('click', event => {
      const rect = element.getBoundingClientRect();
      if (event.target === element && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
    });
    try {
      document.body.appendChild(element);
      element.showModal();
      dialog = element; pending = true; anyShown = true; seen.add(info.key);
      return true;
    } catch (_) { element.remove(); return false; }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-type="add-to-cart-form"]')) return;
    if (bypass.has(form)) { bypass.delete(form); return; }
    if (!allowed()) return;
    if (pending) { event.preventDefault(); event.stopImmediatePropagation(); return; }
    try {
      if (!form.reportValidity()) return;
      const variantInput = form.querySelector('[name="id"]');
      const info = match(productFor(form), variantInput && variantInput.value, read());
      if (!info) return;
      const selectedId = variantInput.value;
      const submitter = event.submitter;
      const displayed = show(info, () => {
        if (!form.isConnected) return;
        // If another script changed size while open, run the check again on the new size.
        if (variantInput.value === selectedId) bypass.add(form);
        try { form.requestSubmit(submitter && submitter.isConnected ? submitter : undefined); }
        finally { bypass.delete(form); }
      });
      if (displayed) { event.preventDefault(); event.stopImmediatePropagation(); }
    } catch (_) { /* Failure must leave the existing purchase flow intact. */ }
  }, true);
  window.NSExchangeReminder = {
    version: '1.0',
    wasShown: () => anyShown,
    getPurchases: read,
    clear() { try { localStorage.removeItem(config.storageKey); } catch (_) {} seen.clear(); close(); },
    consentChanged() { if (!allowed()) this.clear(); },
    // Test-only: seed a purchase for the product currently displayed. No order or tracking event.
    testPurchase(size) {
      if (!allowed()) throw new Error('Exchange reminder is disabled by consent/config.');
      const node = document.querySelector('.ns-exchange-product');
      if (!node) throw new Error('Open a product page first.');
      const product = JSON.parse(node.textContent);
      const index = sizeIndex(product);
      const variant = product.variants.find(v => numericSize((v.options || [v.option1,v.option2,v.option3])[index]) === numericSize(size));
      if (index < 0 || !variant) throw new Error('Size not found.');
      const records = read().filter(r => id(r.productId) !== id(product.id));
      records.push({productId: id(product.id), variantId: id(variant.id), at: Date.now()});
      localStorage.setItem(config.storageKey, JSON.stringify(records));
      seen.clear(); return {product: product.title, size};
    }
  };
  window.addEventListener('ns:exchange-consent-changed', () => window.NSExchangeReminder.consentChanged());
})();
